import React, { Component } from 'react'
import {Button} from 'semantic-ui-react';
import FairApi from '../utils/FairApi'

class ApplyFAIR extends Component {

  handleClick = () => {
    console.log('this is:', this);
    FairApi.generateScores()
  }

  render() {
    return (
      <Button onClick={this.handleClick}>
        Run FAIR
      </Button>
    );
  }
}

export default ApplyFAIR;



// WEBPACK FOOTER //
// ./src/components/admin/ApplyFAIR.js